import { safeSessionStorage } from '@/lib/storage/safe-storage';

const CONVERSATIONS_STARTED_KEY = 'bazak:conversations_started';
const MAX_TRACKED_CONVERSATIONS = 50;

function getStartedList(): string[] {
  const raw = safeSessionStorage.getItem(CONVERSATIONS_STARTED_KEY);
  if (!raw) return [];
  try {
    return JSON.parse(raw);
  } catch {
    return [];
  }
}

export function hasConversationStarted(threadId: string): boolean {
  return getStartedList().includes(threadId);
}

export function markConversationStarted(threadId: string): void {
  const started = getStartedList();
  if (started.includes(threadId)) return;
  started.push(threadId);
  if (started.length > MAX_TRACKED_CONVERSATIONS) started.shift();
  safeSessionStorage.setItem(CONVERSATIONS_STARTED_KEY, JSON.stringify(started));
}
